module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-6-5ec7bdae2c1f1e4a1628f5b0526da3aa.jpg";